/* This index is created to avoid dependency cycle warning. */

import Panel from './Panel';

export default Panel;
